import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * ✕印アイコン
 */
const CloseIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
      >
        <g transform="translate(-314 -2658)">
          <g transform="translate(320.899 2655) rotate(45)">
            <path
              d="M1539.54-1410.08v-4.847h-4.84a1.077,1.077,0,0,1-1.077-1.076,1.077,1.077,0,0,1,1.077-1.077h4.846v-4.847a1.077,1.077,0,0,1,1.077-1.076,1.077,1.077,0,0,1,1.077,1.076v4.847h4.846a1.077,1.077,0,0,1,1.077,1.077,1.077,1.077,0,0,1-1.077,1.076H1541.7v4.847a1.077,1.077,0,0,1-1.077,1.076,1.076,1.076,0,0,1-.765-.313,1.077,1.077,0,0,1-.318-.763Z"
              transform="translate(-1533.62 1423)"
            />
          </g>
        </g>
      </svg>
    </Icon>
  )
}

export default CloseIcon
